import React from 'react'
import { config } from '../Config/config'
import IdleTimer from 'react-idle-timer'
export default class Header extends React.Component {
    constructor(props) {
        super(props)
        this.idleTimer = null
        this.handleOnAction = this.handleOnAction.bind(this)
        this.handleOnActive = this.handleOnActive.bind(this)
        this.handleOnIdle = this.handleOnIdle.bind(this)
    }

    handleOnAction(event) {
        console.log('user did something', event)
    }

    handleOnActive(event) {
        console.log('user is active', event)
        console.log('time remaining', this.idleTimer.getRemainingTime())
    }

    handleOnIdle(event) {
        alert('session is end')
        console.log('user is idle', event)
        console.log('last active', this.idleTimer.getLastActiveTime())
        this.onLogout()
    }

    onLogout = () => {

        //setting session
        localStorage.clear()
        // console.log(respon.result.name)
        // console.log(respon.result._id)
        window.location = '/'

    }


    render() {
        let img = localStorage.getItem(config.image_path)
        // if (localStorage.getItem(config.image_path)) {
        //     "assets/img/user.jpg" img = 
        // }
        console.log(localStorage.getItem(config.remember))
            return (
                <div>
                {localStorage.getItem(config.remember)=="false" ?
                <>
                    <IdleTimer
                        ref={ref => { this.idleTimer = ref }}
                        timeout={1000 * 3600 * 1}
                        onActive={this.handleOnActive}
                        onIdle={this.handleOnIdle}
                        onAction={this.handleOnAction}
                        debounce={250}
                    />
                    <div>
                        <div class="header">
                            <div class="header-left">
                                <a href="/" class="logo">
                                    <img src="assets/img/logo.png" width="35" height="35" alt="" /> <span>Med.Id</span>
                                </a>
                            </div>
                            <a id="toggle_btn" href="javascript:void(0);"><i class="fa fa-bars"></i></a>

                            <div class="row">
                                <div class="header-middle col">
                                    <div class="input-group">
                                        <input class="form-control rounded-left" type="text" placeholder="Cari Dokter atau Faskes" />
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ul class="nav user-menu header-right">
                                    <li class="nav-item dropdown has-arrow">
                                        <a href="#" class="dropdown-toggle nav-link user-link" data-toggle="dropdown">
                                            <span class="user-img"><img class="rounded-circle mr-2" src={img} width="40" /> </span>
                                            <span>{(localStorage.getItem(config.username)).slice(0, 12)}</span>
                                        </a>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="/profile">My Profile</a>
                                            <a class="dropdown-item" href="/" onClick={this.onLogout}>Logout</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </>
                :
                <>
                <div>
                        <div class="header">
                            <div class="header-left">
                                <a href="/" class="logo">
                                    <img src="assets/img/logo.png" width="35" height="35" alt="" /> <span>Med.Id</span>
                                </a>
                            </div>
                            <a id="toggle_btn" href="javascript:void(0);"><i class="fa fa-bars"></i></a>

                            <div class="row">
                                <div class="header-middle col">
                                    <div class="input-group">
                                        <input class="form-control rounded-left" type="text" placeholder="Cari Dokter atau Faskes" />
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" type="button">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <ul class="nav user-menu header-right">
                                    <li class="nav-item dropdown has-arrow">
                                        <a href="#" class="dropdown-toggle nav-link user-link" data-toggle="dropdown">
                                            <span class="user-img"><img class="rounded-circle mr-2" src={img} width="40" /> </span>
                                            <span>{(localStorage.getItem(config.username)).slice(0, 12)}</span>
                                        </a>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="/profile">My Profile</a>
                                            <a class="dropdown-item" href="/" onClick={this.onLogout}>Logout</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </>
            }
            </div>

        )
    }
}